import React from 'react';
import PropTypes from 'prop-types';

import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Error from './Error';
import Loading from '../shared/Loading';
import { useAnalytics } from '../../lib/analytics';
const Layout = ({
  children,
  error,
  isAuthenticated,
  isLoading,
  onSignOut,
  breadcrumbs,
}) => {
  useAnalytics(window.location);
  return (
    <div>
      <Error error={error} />
      {isLoading ? <Loading /> : ''}

      {isAuthenticated ? (
        <div className="wrapper">
          <Sidebar onSignOut={onSignOut} />
          <main className="main-container">
            <Navbar breadcrumbs={breadcrumbs} />
            <div className="container">{children}</div>
          </main>
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default Layout;

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  onSignOut: PropTypes.func.isRequired,
};
